module.exports = __webpack_public_path__ + "static/media/esri-topo.ecf18f80.png";